import React from "react";
import locale from "@bonliva-crm/locale";
import { ProjectFragment } from "@graphql";
import Select, { SelectProps } from "@components/Select";
import { projectsToOptions } from "./projectsToOptions";
import { useRegularProjects } from "@hooks";

export type ProjectSelectProps = Partial<SelectProps> & {
  options?: ProjectFragment[];
};

export function ProjectSelect(props: ProjectSelectProps) {
  const shouldSkip = Boolean(props.options);
  const { regularProjects, loading } = useRegularProjects(shouldSkip);

  const projects = props.options || regularProjects;
  const options = projectsToOptions(projects);

  return (
    <Select
      {...props}
      multi={props.multi}
      label={locale.Project}
      options={options}
      disabled={loading || props.disabled}
    />
  );
}
